const numberFormatter = new Intl.NumberFormat('it-IT')

export const CAR_DETAILS_LOCATION_PREFIX = 'ArvalItaly'

export const mapLocation = (location) =>
  location
    ? location.replace(new RegExp(CAR_DETAILS_LOCATION_PREFIX, 'i'), '') || '-'
    : location

export const getFormattedKm = (km) => `${numberFormatter.format(km)} km`

export const getFormattedReconditioningEstCost = (reconditioningEstCost) =>
  reconditioningEstCost
    ? `€ ${numberFormatter.format(reconditioningEstCost)}`
    : '-'

export const getFormattedOptionAmount = (optionAmount) =>
  optionAmount ? `€ ${numberFormatter.format(Math.round(optionAmount))}` : '-'
